<div *ngIf="loaded">
  <div class="row">
    <div class="col-md-3 mt-3">
      <ul class="list-group">
        <li class="list-group-item" *ngFor="let item of productCategories">
          <a (click)="productCategorySelected(item.code)">{{ item.description }}</a>
        </li>
      </ul>
    </div>
    <div class="col-md-9">
      <div style="position: relative; height: 500px">
        <canvas
          baseChart
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [options]="lineChartOptions"
          [legend]="lineChartLegend"
          [type]="lineChartType"
        ></canvas>
      </div>
    </div>
  </div>

</div>

<div class="text-center dashboard-loading-spinner" *ngIf="!loaded">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
